import { mainNum } from '../constants'

const validates = {
    mainSpareImage: {
        name: 'mainSpareImage',
        validate: {
            name: '商品轮播图',
            validatorNum: mainNum,
            imageTypeValidator: {
                acceptTypeList: ['image/jpg', 'image/jpeg', 'image/png'],
            },
            rectValidator: {
                minWidth: 480,
                minHeight: 480,
                maxWidth: 2500,
                maxHeight: 2500,
            },
            sizeValidator: {
                maxSize: 3,
            },
            ratioValidator: {
                // eslint-disable-next-line no-magic-numbers
                ratio: [1 / 1, 3 / 4],
                ratioDiffScope: 0.001,
            },
        },
    },
    detailGallery: {
        name: 'detailGallery',
        validate: {
            name: '商品详情图',
            imageTypeValidator: {
                noAcceptTypeList: ['image/gif'],
            },
            rectValidator: {
                minWidth: 480,
                maxWidth: 1200,
                maxHeight: 1500,
            },
            sizeValidator: {
                minSize: 0,
                maxSize: 3,
            },
        },
    },
}

// 给铺货模版的配置
export const goodsQuickSets = [validates.mainSpareImage, validates.detailGallery]

// 商品轮播图、规格图
export default validates
